import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Facilities from "./pages/Facilities";
import Admission from "./pages/Admission";
import Fees from "./pages/Fees";
import Faculty from "./pages/Faculty";
import Contact from "./pages/Contact";

function App() {
  const [mode, setMode] = useState("college");

  return (
    <Router>
      <div className="app-container">

        {/* 🔝 NAVBAR */}
        <Navbar setMode={setMode} mode={mode} />

        {/* MAIN CONTENT */}
        <main className="content">
          <Routes>
            <Route path="/" element={<Home mode={mode} />} />
            <Route path="/about" element={<About mode={mode} />} />
            <Route path="/programs" element={<Programs mode={mode} />} />
            <Route path="/facilities" element={<Facilities mode={mode} />} />
            <Route path="/admission" element={<Admission mode={mode} />} />
            <Route path="/fees" element={<Fees mode={mode} />} />
            <Route path="/faculty" element={<Faculty mode={mode} />} />
            <Route path="/contact" element={<Contact mode={mode} />} />
          </Routes>
        </main>

        {/* ✅ WHATSAPP FLOAT BUTTON (ADD THIS) */}
        <a
          href="https://wa.me/919595302222?text=Hello%20I%20want%20admission%20details"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
            alt="whatsapp"
          />
        </a>

        {/* FOOTER */}
        <Footer mode={mode} />

      </div>
    </Router>
  );
}

export default App;